module.exports = __webpack_public_path__ + "img/feature_buy_en.77cb4ad5.png";